export const Data = [
  {
    type: "zh",
    content: {
      cpjsTatle:"产品介绍",
      cpjsMore:"查看更多",
      cpjsItem:[
        {
          path: "cpjs",

          index:1,
          showData:true,
          imgUrl:"http://116.62.38.250/image/sy/cpjs1.jpg",
          text1:"口腔Er:YAG激光治疗仪",
          text2:"采用军工级别的Er:YAG晶体，产生波长为2940nm的激光，通过手机动态聚焦技术与口腔组织中水分子\n" +
            "的作用，产生“微爆破”反应，实现口腔软、硬组织的汽化，消融切割等治疗效果。"
        },
        {
          path: "gzj",
          index:2,
          showData:true,
          imgUrl:"http://116.62.38.250//image/sy/cpjs2.jpg",
          text1:"激光全能手机",
          text2:"采取直弯头设计，可实现全方位多角度的诊疗模式，可360度旋转，灵活轻巧。"
        },
        {
          path: "sb",
          index:3,
          showData:true,
          imgUrl:"http://116.62.38.250//image/sy/cpjs3.jpg",
          text1:"激光工作尖",
          text2:"非侵入式及吸附锁式设计，达到即插即用，拥有各种直径和长度的规格，可接受高温消毒，实现重复使用，降低使用成本。"
        }
      ]
    }
  }
  ]



// WEBPACK FOOTER //
// ./src/components/js/image/cpjs.js